import { type CommonAction, response, success } from "@iflyrpa/share";
import type { ActiomCommonParams, AxiosProxyParams } from "../../types";
import { DisabledReq } from "../../types";
import { Http } from "../../utils/http";
import { Xhshow } from "../../utils/xhs_ob_feed"; // 使用旧的工作版本

// 小红书参数加密器
const xsEncrypt = new Xhshow();
const GenXSCommon = require("../../utils/XhsXsCommonEnc.js") as (
    a1cookie: string,
    x_t: string | number,
    x_s: string,
) => string;

export interface xiaohongshuWebNoteFeedParams extends ActiomCommonParams {
    source_note_id: string;
    xsec_token: string;
}
export interface FeedResponse {
    code: number;
    success: boolean;
    msg: string;
    data: {
        items: FeedRespomseDetail[];
    } | null;
}

export interface FeedRespomseDetail {
    note_card: Record<string, unknown>;
}

export type PublishAction = CommonAction<xiaohongshuWebNoteFeedParams, FeedRespomseDetail[] | Record<string, unknown>>;

export const xiaohongshuWebNoteFeed: PublishAction = async (_task, params) => {
    if (DisabledReq) return response(414, "获取指定文章详情失败", {});
    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://www.xiaohongshu.com/",
        origin: "https://www.xiaohongshu.com/",
    };

    const args: AxiosProxyParams = [{ headers }, _task.logger, params.proxyLoc, params.accountId];
    const http = new Http(...args);

    const a1Cookie = params.cookies.find((it) => it.name === "a1")?.value;
    if (!a1Cookie) return { code: 414, message: "账号数据异常，请重新绑定账号后重试。", data: {} };
    if (!params.source_note_id && !params.xsec_token) {
        return { code: 414, message: "参数缺失，请检查后重试！", data: {} };
    }

    const feedParams = {
        source_note_id: params.source_note_id,
        image_formats: ["jpg", "webp", "avif"],
        extra: { need_body_topic: "1" },
        xsec_source: "pc_feed",
        xsec_token: params.xsec_token,
    };

    const fatchFeed = "/api/sns/web/v1/feed";
    const recordCookie = params.cookies.reduce<Record<string, string>>((acc, cookie) => {
        if (cookie.name && cookie.value) {
            acc[cookie.name] = cookie.value;
        }
        return acc;
    }, {});

    // 使用旧的签名算法（只返回 X-S）
    const xsHeader = xsEncrypt.signHeadersPost(fatchFeed, recordCookie, "xhs-pc-web", feedParams);

    // 生成时间戳
    const xT = Date.now().toString();

    // 使用 GenXSCommon 生成 x-s-common
    const xsCommon = GenXSCommon(a1Cookie, xT, xsHeader["X-S"]);

    _task.logger.info(`请求参数: ${JSON.stringify(feedParams)}`);
    _task.logger.info(`X-S: ${xsHeader["X-S"]}`);
    _task.logger.info(`x-s-common: ${xsCommon}`);

    const res = await http.api<FeedResponse>(
        {
            method: "post",
            url: "https://edith.xiaohongshu.com/api/sns/web/v1/feed",
            data: feedParams,
            headers: {
                "X-S": xsHeader["X-S"],
                "X-S-Common": xsCommon,
                "X-T": xT,
            },
        },
        { retries: 3, retryDelay: 20, timeout: 3000 },
    );

    // 添加详细日志
    _task.logger.info(`API 响应: ${JSON.stringify(res)}`);

    const isSuccess = res.code === 0 && res.data && res.data?.items && res.data?.items.length > 0;
    const message = `获取指定文章详情${isSuccess ? "成功" : `失败，原因：${res.msg || "返回数据为空，可能笔记不存在或参数错误"}`}${_task.debug ? ` ${http.proxyInfo}` : ""}`;
    const data = isSuccess ? res.data?.items[0].note_card || {} : {};

    return response(isSuccess ? 0 : 414, message, data);
};
